<template>
    <Stub />
</template>

<script>
import Stub from '@/components/common/Stub';

export default {
    name: 'CharityReports',
    components: {
        Stub,
    },
};
</script>
